/**
 * CargaMedlog
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {CargaMedlogCollection} from '@/model/collection/CargaMedlogCollection'

/* TODO: review generated class */
export class CargaMedlog extends Resource {
  idCargaMedlogPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  erro: string | null = null

  get $id() {
    return this.idCargaMedlogPk
  }
  set $id(val) {
    this.idCargaMedlogPk = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaMedlog
   */
  async getCargaMedlog(id: number) {
    return await Request.get(`/admin/carga-medlog/${id}`)
      .name('getCargaMedlog')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaMedlog
   */
  static async listCargaMedlog(params: any) {
    return await Request.get(`/admin/carga-medlog`, {params})
      .name('listCargaMedlog')
      .as(CargaMedlogCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaMedlog. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaMedlog() {
    return await Request.post(`/admin/carga-medlog`, this)
      .name('persistCargaMedlog')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaMedlog to use it in a CSV file
   */
  static async listCsvCargaMedlog(params: any) {
    return await Request.get(`/admin/carga-medlog/csv`, {params})
      .name('listCsvCargaMedlog')
      .as(CargaMedlogCollection)
      .getData()
  }
}
